import { useCallback } from 'react';
import useUser from '@alltrails/context/hooks/useUser';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import useExperiments from '@alltrails/experiments/hooks/useExperiments';
import useExposureEvent from '@alltrails/experiments/hooks/useExposureEvent';

const EXPERIMENT_KEY = 'web-growth-rm-unauth-install-nudge-hero-map-v2';

export default function useMapSignupBypass() {
  const user = useUser();
  const isMobile = useIsMobileSizedScreen();
  const experiments = useExperiments();
  const sendExposureEvent = useExposureEvent(EXPERIMENT_KEY);

  const isEligible = !user && isMobile;
  const experimentValue = experiments[EXPERIMENT_KEY]?.value;

  const shouldShowAuthOnLoad = isEligible && experimentValue === 'auth-only';
  const shouldShowInstallPromptOnLoad = isEligible && experimentValue === 'install-prompt-then-auth';
  const shouldBypassSignup = shouldShowAuthOnLoad || shouldShowInstallPromptOnLoad;

  const sendExposure = useCallback(() => {
    if (isEligible) {
      sendExposureEvent();
    }
  }, [isEligible, sendExposureEvent]);

  return { shouldShowAuthOnLoad, shouldShowInstallPromptOnLoad, shouldBypassSignup, sendExposure };
}
